import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { btnLift, focusRing } from "./styles";

export const NOTIFY_INPUT_ID = "broker-notify-email";

interface FieldsProps {
  email: string;
  onEmail?: (value: string) => void;
  busy: boolean;
  message?: string;
}

/** Shared markup so the lazy-loading placeholder and the live form look the same. */
export const NotifyFields = ({ email, onEmail, busy, message }: FieldsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <label htmlFor={NOTIFY_INPUT_ID} className="block text-sm font-semibold text-foreground">
        {t("home.broker.emailLabel")}
      </label>
      <div className="mt-2.5 flex flex-wrap gap-2.5">
        <input
          id={NOTIFY_INPUT_ID}
          type="email"
          name="email"
          autoComplete="email"
          inputMode="email"
          required
          maxLength={255}
          placeholder={t("home.broker.placeholder")}
          value={email}
          onChange={(e) => onEmail?.(e.target.value)}
          readOnly={!onEmail}
          disabled={busy}
          className="h-[52px] min-w-0 flex-[1_1_220px] rounded-full border border-foreground/20 bg-background px-5 text-base text-foreground outline-none transition-[border-color,box-shadow] placeholder:text-pf-ink2/80 focus:border-primary focus:ring-4 focus:ring-primary/20 disabled:opacity-70"
        />
        <button
          type="submit"
          disabled={busy}
          className={`h-[52px] flex-none cursor-pointer rounded-full bg-primary px-6 text-base font-semibold text-white disabled:cursor-wait disabled:opacity-70 ${btnLift} ${focusRing}`}
        >
          {busy ? t("home.broker.sending") : t("home.broker.submit")}
        </button>
      </div>
      <p aria-live="polite" className="mt-2.5 min-h-6 text-sm font-medium text-primary">
        {message}
      </p>
      <p className="mt-1 text-[13px] leading-normal text-pf-ink2">
        {t("home.broker.consent")}{" "}
        <Link to="/privacy" className={`font-medium text-primary underline-offset-2 hover:underline ${focusRing}`}>
          {t("home.broker.privacyLink")}
        </Link>
      </p>
    </>
  );
};
